module.exports = __webpack_public_path__ + "img/2.11ffa4a2.jpg";